import { useTranslation } from 'react-i18next';
import { GhostLoader } from '../../../../components/GhostLoader';
import classes from './PublicSurveyLoading.module.css';

const METRICS_CARDS_COUNT = 4;
const HEADER_HEIGHT = 140;
const CARD_HEIGHT = 150;

export const PublicSurveyLoading = () => {
  const { t } = useTranslation();

  return (
    <>
      <GhostLoader
        aria-busy="true"
        aria-label={t('publicSurveyLoading.loadingSurveyLabel')}
        style={{ width: '100%', height: HEADER_HEIGHT }}
      />
      <div className={classes.loaderCards}>
        {Array.from({ length: METRICS_CARDS_COUNT }).map((_, index) => (
          <GhostLoader
            key={index}
            aria-busy="true"
            aria-label={`${t('publicSurveyLoading.loadingCategoryLabel')} ${index + 1}`}
            style={{ width: '100%', height: CARD_HEIGHT }}
          />
        ))}
      </div>
    </>
  );
};
